import React from 'react';
import ReactTable from 'react-table';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import moment from 'moment';

// @material-ui/core components
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import withStyles from '@material-ui/core/styles/withStyles';
import Slide from '@material-ui/core/Slide';
import DialogActions from '@material-ui/core/DialogActions';
import Alert from '@material-ui/icons/NotificationImportant';
import Snackbar from '../../../components/Snackbar/Snackbar';

// material-ui icons
import ListAlt from '@material-ui/icons/ListAlt';
import Edit from '@material-ui/icons/Edit';
import Check from '@material-ui/icons/Check';
import Close from '@material-ui/icons/Close';

// core components
import GridContainer from '../../../components/Grid/GridContainer.jsx';
import GridItem from '../../../components/Grid/GridItem.jsx';
import Card from '../../../components/Card/Card.jsx';
import CardHeader from '../../../components/Card/CardHeader.jsx';
import CardIcon from '../../../components/Card/CardIcon.jsx';
import CardBody from '../../../components/Card/CardBody.jsx';
import Button from '../../../components/CustomButtons/Button.jsx';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';

import { cardTitle } from '../../../assets/jss/material-dashboard-pro-react.jsx';

import {
  fetchValidations,
  updateValidation,
  resetValidationInfo,
} from '../../../actions/validationAction';
import { fetchCurrentUser } from '../../../actions/loginAction';

import { filterMethod, formataCPF } from '../../../helpers/utils';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class ValidationListTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: null,
      motivoStatus: [],
      otherVisible: false,
      deleteUserConfirmationModal: false,
      deleteUserConfirmationToggle: false,
      activateUserConfirmationModal: false,
      activateUserConfirmationToggle: false,
      note: '',
      noteValid: true,
      idPerfil: '',
      idCliente: '',
      countChar: 0,
      countCharMessage: '',
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    if (prevProps.tableData !== this.props.tableData) {
      this.setState({ tableData: this.props.tableData }, () => {
        this.handleData();
      });
    }

    if (
      this.props.updateValidation &&
      prevProps.updateValidation !== this.props.updateValidation
    ) {
      this.setState(
        {
          notificationMessage: 'Dados atualizados',
        },
        () => this.showNotification('primary')
      );
    }
    if (
      this.props.updateValidationError &&
      prevProps.updateValidationError !== this.props.updateValidationError
    ) {
      this.setState(
        { notificationMessage: this.props.updateValidationError },
        () => this.showNotification('danger')
      );
    }
  }

  componentWillUnmount() {
    this.props.resetValidationInfo();
  }

  handleModalOpen(modal) {
    this.setState({ [modal]: true });
  }

  handleModalClose(modal) {
    this.setState({ [modal]: false });
  }

  handleData = () => {
    const usersData = this.state.tableData.map((prop, key) => {
      return {
        id: key,
        userId: prop.id,
        nome: prop.client.name,
        email: prop.client.email,
        cpf: prop.client.social_number
          ? formataCPF(prop.client.social_number)
          : '',
        dataCadastro: moment(prop.created_at).format('DD/MM/YYYY'),
        ativo: prop.blocked === true ? 'Não' : 'Sim',
        action: (
          <Button
            justIcon
            round
            simple
            title="Alterar status"
            onClick={() => {
              this.setState({ idPerfil: prop.id, idCliente: prop.client_id });
              this.handleModalOpen('editStatusModal');
            }}
            style={{ marginTop: '0px', marginBottom: '0px' }}
            color="info"
          >
            <Edit />
          </Button>
        ),
      };
    });
    this.setState({ usersData });
  };

  handleChange = (name) => (e) => {
    const { value } = e.target;
    let { idMotivoReprovar } = this.state;

    // this.setState({[name]: value});

    // if (name === ID_MOTIVO_REPROVAR) {
    //   if (value.toString() === '8') {
    //     this.setState({otherVisible: !this.state.otherVisible}, ()=> {
    //       if (!this.state.otherVisible) {
    //         this.setState({...this.state, motivoRecusaOutros : '', reasonValid: true})
    //       } else {
    //         this.setState({reasonValid: false})
    //       }
    //     });
    //   }

    //   let index = idMotivoReprovar.indexOf(value);

    //   index !== -1 ? idMotivoReprovar.splice(index, 1) : idMotivoReprovar.push(value);
    //   this.setState({[name]: idMotivoReprovar});
    // }
  };

  handleTextareaChange = (e) => {
    const { value } = e.target;
    let noteValid;

    noteValid = value !== '' ? true : false;

    this.setState({ note: value, noteValid, countChar: value.length });
  };

  handleClickOpen(modal) {
    var x = [];
    x[modal] = true;
    this.setState(x);
  }

  handleClose(modal) {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  handleDeleteUser() {
    let payload = {
      id: this.state.idPerfil,
      blocked: true,
      client_id: this.state.idCliente,
      banned_reason: this.state.note,
    };

    this.props.updateValidation(payload);
  }

  handleActivateUser() {
    let payload = {
      id: this.state.idPerfil,
      blocked: false,
      client_id: this.state.idCliente,
      banned_reason: '',
    };
    this.props.updateValidation(payload);
  }

  showNotification(color = 'primary') {
    if (this.state['showNotification']) return;

    let state = [];
    state['showNotification'] = true;
    state['notificationColor'] = color;

    this.setState(state, () => {
      this.props.resetUserInfo();
      setTimeout(
        function() {
          state['showNotification'] = false;
          state['notificationColor'] = color;
          state['notificationMessage'] = '';
          this.setState(state);
        }.bind(this),
        4000
      );
    });
  }

  closeNotification = () => {
    let state = [];
    state['showNotification'] = false;
    state['notificationMessage'] = '';
    this.setState(state);
  };

  render() {
    const { classes } = this.props;
    let limit = Number(100) - this.state.countChar;

    let notification = (
      <Snackbar
        place="br"
        color={this.state.notificationColor || 'primary'}
        icon={Alert}
        message={this.state.notificationMessage}
        open={this.state.showNotification}
        closeNotification={this.closeNotification}
        close
      />
    );

    let editStatusModal = (
      <GridContainer justify="center">
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          classes={{
            root: classes.modalRoot,
            paper: classes.modal + ' ' + classes.modalSmall,
          }}
          open={this.state.editStatusModal}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleModalClose('editStatusModal')}
          aria-labelledby="small-modal-slide-title"
          aria-describedby="small-modal-slide-description"
        >
          <DialogTitle
            id="small-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
            <h5 className={classes.modalTitle}>Alterar status</h5>
          </DialogTitle>
          <DialogContent
            id="small-modal-slide-description"
            className={classes.modalBody + ' ' + classes.modalSmallBody}
          >
            <p className={classes.modalTitle}>
              Por favor, validar o cadastro do perfil
            </p>
          </DialogContent>
          <DialogActions className={classes.modalFooter}>
            <Button
              color="success"
              onClick={() => {
                this.handleClickOpen('activateUserConfirmationModal');
                this.handleModalClose('editStatusModal');
              }}
              activateUserConfirmationModal
            >
              <Check /> Ativar
            </Button>
            <Button
              onClick={() => {
                this.handleClickOpen('deleteUserConfirmationModal');
                this.handleModalClose('editStatusModal');
              }}
              color="danger"
            >
              <Close /> Desativar
            </Button>
            {/* <Button
              onClick={() => {
                this.props.reproveAd(this.getIdStatusAprovacao(), this.state.idMotivoReprovar, this.state.motivoRecusaOutros)
              }}
              // disabled={!this.state.idMotivoReprovar.length || !this.state.reasonValid}
              color="success"
              simple
              className={
                classes.modalSmallFooterFirstButton +
                " " +
                classes.modalSmallFooterSecondButton
              }
            >
              Confirmar
            </Button>
            <Button
              onClick={() => {
                this.handleModalClose('editStatusModal');
              }}
              link
              className={classes.modalSmallFooterFirstButton}
            >
              Cancelar
            </Button> */}
          </DialogActions>
        </Dialog>
      </GridContainer>
    );

    let deleteUserConfirmationModal = (
      <GridContainer justify="center">
        <Dialog
          classes={{
            root: classes.modalRoot,
            paper: classes.modal + ' ' + classes.modalSmall,
          }}
          open={this.state.deleteUserConfirmationModal}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleClose('deleteUserConfirmationModal')}
          aria-labelledby="small-modal-slide-title"
          aria-describedby="small-modal-slide-description"
        >
          <DialogTitle
            id="small-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
            <h3 className={classes.modalTitle}>Desativar Usuário</h3>
          </DialogTitle>
          <DialogContent
            id="small-modal-slide-description"
            className={classes.modalBody + ' ' + classes.modalSmallBody}
          >
            <h5>
              Após desativado, o usuário em questão não poderá mais logar no
              sistema. Para continuar, descreva o motivo da desativação.
            </h5>
            <Grid
              item
              xs={12}
              md={12}
              sm={12}
              style={{ paddingTop: '11px', paddingRight: '16px' }}
            >
              <FormControl
                component="fieldset"
                className={classes.formControlTextarea}
              >
                <textarea
                  id="note"
                  row={3}
                  className="note"
                  maxLength={100}
                  placeholder="Descreva aqui o motivo"
                  onKeyUp={this.handleTextareaChange}
                  style={{ height: '100px' }}
                ></textarea>
                <div class="text">
                  <p className="countChar">Restam {limit} caracteres</p>
                  {!this.state.noteValid && (
                    <span class="text-error">Informe uma nota</span>
                  )}
                </div>
              </FormControl>
            </Grid>
          </DialogContent>
          <DialogActions
            className={classes.modalFooter + ' ' + classes.modalFooterCenter}
          >
            <Button
              onClick={() => {
                this.handleDeleteUser();
                this.handleClose('deleteUserConfirmationModal');
              }}
              color="success"
              simple
              disabled={!this.state.note}
              className={
                classes.modalSmallFooterFirstButton +
                ' ' +
                classes.modalSmallFooterSecondButton
              }
            >
              Confirmar
            </Button>
            <Button
              onClick={() => {
                this.handleClose('deleteUserConfirmationModal');
                this.setState({ note: '', noteValid: true });
              }}
              link
              className={classes.modalSmallFooterFirstButton}
            >
              Cancelar
            </Button>
          </DialogActions>
        </Dialog>
      </GridContainer>
    );

    let activateUserConfirmationModal = (
      <GridContainer justify="center">
        <Dialog
          classes={{
            root: classes.modalRoot,
            paper: classes.modal + ' ' + classes.modalSmall,
          }}
          open={this.state.activateUserConfirmationModal}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleClose('activateUserConfirmationModal')}
          aria-labelledby="small-modal-slide-title"
          aria-describedby="small-modal-slide-description"
        >
          <DialogTitle
            id="small-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
            <h3 className={classes.modalTitle}>Ativar Usuário</h3>
          </DialogTitle>
          <DialogContent
            id="small-modal-slide-description"
            className={classes.modalBody + ' ' + classes.modalSmallBody}
          >
            <h5>
              Após ativado, o usuário em questão poderá acessar o sistema. Tem
              certeza que deseja continuar?
            </h5>
          </DialogContent>
          <DialogActions
            className={classes.modalFooter + ' ' + classes.modalFooterCenter}
          >
            <Button
              onClick={() => {
                this.handleActivateUser();
                this.handleClose('activateUserConfirmationModal');
              }}
              color="success"
              simple
              // xdisabled={!this.state.activateUserConfirmationToggle}
              className={
                classes.modalSmallFooterFirstButton +
                ' ' +
                classes.modalSmallFooterSecondButton
              }
            >
              Confirmar
            </Button>
            <Button
              onClick={() => this.handleClose('activateUserConfirmationModal')}
              link
              className={classes.modalSmallFooterFirstButton}
            >
              Cancelar
            </Button>
          </DialogActions>
        </Dialog>
      </GridContainer>
    );

    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <ListAlt />
              </CardIcon>
            </CardHeader>
            <CardBody>
              <ReactTable
                data={this.state.usersData}
                noDataText="Carregando dados..."
                filterable
                defaultFilterMethod={filterMethod}
                columns={[
                  {
                    Header: 'Nome',
                    accessor: 'nome',
                  },
                  {
                    Header: 'Email',
                    accessor: 'email',
                  },
                  {
                    Header: 'CPF',
                    accessor: 'cpf',
                  },
                  {
                    Header: 'Cadastro',
                    accessor: 'dataCadastro',
                    sortMethod: (a, b) => {
                      if (!a || !b) return 0;

                      let dateA = a.split('/');
                      dateA = dateA[2] + '-' + dateA[1] + '-' + dateA[0];
                      dateA = new Date(dateA);

                      let dateB = b.split('/');
                      dateB = dateB[2] + '-' + dateB[1] + '-' + dateB[0];
                      dateB = new Date(dateB);

                      if (dateA > dateB) return -1;
                      if (dateA < dateB) return 1;
                      return 0;
                    },
                  },
                  {
                    Header: 'Ativo',
                    accessor: 'ativo',
                  },
                  {
                    Header: 'Alterar Status',
                    accessor: 'action',
                  },
                ]}
                defaultSorted={[
                  {
                    id: 'ativo',
                    desc: true,
                  },
                  {
                    id: 'nome',
                    desc: false,
                  },
                ]}
                getTrProps={(state, rowInfo, column) => {
                  return {
                    style: {
                      cursor: 'pointer',
                    },
                  };
                }}
                defaultPageSize={10}
                showPaginationTop={false}
                showPaginationBottom={true}
                showPageSizeOptions={false}
                showPageJump={false}
                previousText="Anterior"
                nextText="Próximo"
                pageText="Página"
                ofText="de"
                className="-striped -highlight"
              />
            </CardBody>
          </Card>
        </GridItem>
        {editStatusModal}
        {deleteUserConfirmationModal}
        {activateUserConfirmationModal}
        {notification}
      </GridContainer>
    );
  }
}

ValidationListTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    authenticatedUser: state.loginReducer.authenticatedUser,
    validation: state.validationReducer.validation,
    validationError: state.validationReducer.validation_error,
    updateValidation: state.validationReducer.update_validation,
    updateValidationError: state.validationReducer.update_validation_error,
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    fetchCurrentUser,
    fetchValidations,
    updateValidation,
    resetValidationInfo,
  })
)(withRouter(ValidationListTable));
